import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';
import Fade from 'embla-carousel-fade';

import { addEmblaDotClickHandlers, addPrevNextBtnsClickHandlers } from '../utils/emblaCarouselExtensions';

const initEmblaCarousel = () => {

    const emblaIBanner = document.querySelector('.embla-banner');
    if (emblaIBanner) {
        const emblaViewport = <HTMLElement>emblaIBanner.querySelector('.embla__viewport');
        const autoplay = Autoplay({ playOnInit: true });
        const emblaApi = EmblaCarousel(emblaViewport, { loop: true }, [autoplay as any]);

        const btnPrev = <HTMLElement>emblaIBanner.querySelector('.embla-banner-prev');
        const btnNext = <HTMLElement>emblaIBanner.querySelector('.embla-banner-next');

        const dots = Array.from(emblaIBanner.querySelectorAll('.embla__dot')) as HTMLElement[];


        addEmblaDotClickHandlers(emblaApi, dots);

        addPrevNextBtnsClickHandlers(emblaApi, btnPrev, btnNext);

    }

    const emblapProd = document.querySelector('.embla-prod');
    if (emblapProd) {
        const emblaViewport = <HTMLElement>emblapProd.querySelector('.embla__viewport');
        const autoplay = Autoplay({ playOnInit: true });
        const emblaApi = EmblaCarousel(emblaViewport, { loop: true }, [autoplay as any]);

        const dots = Array.from(emblapProd.querySelectorAll('.embla__dot')) as HTMLElement[];

        addEmblaDotClickHandlers(emblaApi, dots);
    }

    const emblapProdb = document.querySelector('.embla-prodb');
    if (emblapProdb) {
        const emblaViewport = <HTMLElement>emblapProdb.querySelector('.embla__viewport');
        const autoplay = Autoplay({ playOnInit: true });
        const emblaApi = EmblaCarousel(emblaViewport, { loop: true }, [autoplay as any]);

        const btnPrev = <HTMLElement>emblapProdb.querySelector('.embla-btn-prev');
        const btnNext = <HTMLElement>emblapProdb.querySelector('.embla-btn-next');

        const dots = Array.from(emblapProdb.querySelectorAll('.embla__dot')) as HTMLElement[];


        addEmblaDotClickHandlers(emblaApi, dots);

        addPrevNextBtnsClickHandlers(emblaApi, btnPrev, btnNext);
    }

    const emblapPartner = document.querySelector('.embla-partner');
    if (emblapPartner) {
        const emblaViewport = <HTMLElement>emblapPartner.querySelector('.embla__viewport');
        // const autoplay = Autoplay({ playOnInit: true });
        const autoScrollPlugin = AutoScroll({ speed: 1, stopOnMouseEnter: true, startDelay: 100 });
        const emblaApi = EmblaCarousel(emblaViewport, { loop: true, align: 'center' }, [autoScrollPlugin as any]);

        // 获取容器（视口）的宽度
        const containerWidth = emblaApi.rootNode().getBoundingClientRect().width

        // 获取所有 Slide 的总宽度
        const slidesInViewWidth = emblaApi.slideNodes().reduce((total, slide) => {
            return total + slide.getBoundingClientRect().width
        }, 0)

        if (slidesInViewWidth <= containerWidth) {
            // console.log("内容不足，应该居中");
            emblapPartner.classList.add('center');
        } else {
            emblapPartner.classList.remove('center');
        }


        emblapPartner.addEventListener('mouseleave', () => {
            // 重新启动自动滚动
            autoScrollPlugin.play();
        });
    }


    const emblapIabout = document.querySelector('.embla-iabout');
    if (emblapIabout) {
        const emblaViewport = <HTMLElement>emblapIabout.querySelector('.embla__viewport');
        const autoplay = Autoplay({ playOnInit: true });
        const emblaApi = EmblaCarousel(emblaViewport, { loop: true, startIndex: 1, duration: 45 }, [autoplay as any, Fade() as any]);

        const dots = Array.from(document.querySelectorAll('.list-iabout-dots > li')) as HTMLElement[];

        addEmblaDotClickHandlers(emblaApi, dots);
    }


    // Index custom
    const emblaIcustom = document.querySelectorAll('.embla-icustom');
    if (emblaIcustom.length) {
        emblaIcustom.forEach((icustom, index) => {
            const emblaViewport = <HTMLElement>icustom.querySelector('.embla__viewport');
            const autoplay = Autoplay({ playOnInit: true });
            const emblaApi = EmblaCarousel(emblaViewport, { loop: true, startIndex: 1, duration: 30 }, [autoplay as any]);

            const dots = Array.from(icustom.querySelectorAll('.embla__dot')) as HTMLElement[];

            addEmblaDotClickHandlers(emblaApi, dots);
        });

        const icustomTabs = document.querySelectorAll('.icustom-tab > div');
        const icustomItems = document.querySelectorAll('.icustom-item');
        icustomTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                icustomTabs.forEach((t, j) => {
                    t.classList.toggle('current', index === j);
                });
                icustomItems.forEach((item, j) => {
                    item.classList.toggle('active', index === j);
                });
            });
        });
    }


};

export { initEmblaCarousel };
